import React from 'react'
import HeadCommon from '../../commons/Head/Head'
import config from '../../../config/index'

const Head = () => {
  const { site: siteConfig } = config

  return (
    <HeadCommon>
      <meta charSet={siteConfig.charset} />
      <meta httpEquiv="x-ua-compatible" content="ie=edge" />
      <meta name="viewport" content={siteConfig.viewport} />

      {siteConfig.robots && <meta name="robots" content={siteConfig.robots} />}

      {siteConfig.openGraph.status && (
        <>
          <meta property="og:type" content={siteConfig.openGraph.type} />
          <meta property="og:url" content={siteConfig.openGraph.url} />
          <meta property="og:title" content={siteConfig.openGraph.title} />
          <meta
            property="og:description"
            content={siteConfig.openGraph.description}
          />
          <meta property="og:image" content={siteConfig.openGraph.image} />
        </>
      )}

      {siteConfig.twitter.status && (
        <>
          <meta property="twitter:card" content={siteConfig.twitter.card} />
          <meta property="twitter:url" content={siteConfig.twitter.url} />
          <meta property="twitter:title" content={siteConfig.twitter.title} />
          <meta
            property="twitter:description"
            content={siteConfig.twitter.description}
          />
          <meta property="twitter:image" content={siteConfig.twitter.image} />
        </>
      )}
    </HeadCommon>
  )
}

export default Head
